module.exports = "../../app/cells/pages/bifrost/study_guides/menu_bar_float_cell.rb";